module.exports = __webpack_public_path__ + "img/t2-c24.3511c024.png";